import { ChainId, NETWORK_CONFIG, Token } from 'constant';
import React from 'react';
import styled from 'styled-components';
import Modal from '../Modal';
import { Link, TYPE } from '../../theme';
import { AlertTriangle } from 'react-feather';
import Button from '../Button';
import { AutoColumn } from '../Column';
import { useAddToken } from 'hooks/useAddToken';
import { observer } from 'mobx-react-lite';
import user from 'stores/user';
import application from 'stores/application';
import { metamaskSmallLogo } from 'common-helpers/img';
import Loading from 'components/Loading';

const Wrapper = styled.div`
    width: 100%;
`;
const Section = styled(AutoColumn)`
    padding: 24px;
`;

const BottomSection = styled(Section)`
    /* background-color: #ccc; */
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
`;

const AddToken = styled.div`
    border-radius: 12px;
    padding: 14px;
    box-sizing: border-box;
    background: #000;
    font-size: 14px;
    color: #fff;
    display: flex;
    align-items: center;
    margin-top: 1rem;
    cursor: pointer;
    .metamaskLogo {
        margin-right: 8px;
        width: 20px;
        height: 20px;
    }
`;

const StyleLoading = styled(Loading)`
    margin: 20px 0;
    color: #fff;
`;

function ConfirmationPendingContent({ onDismiss, pendingText }: { onDismiss: () => void; pendingText: string }) {
    return (
        <Wrapper>
            <Section>
                <AutoColumn gap="12px" justify={'center'}>
                    <TYPE.main fontWeight={500} fontSize={20}>
                        Waiting For Confirmation
                    </TYPE.main>
                    <StyleLoading size={64} />
                    <AutoColumn gap="12px" justify={'center'}>
                        <TYPE.main fontWeight={600} fontSize={14} textAlign="center">
                            {pendingText}
                        </TYPE.main>
                    </AutoColumn>
                    <TYPE.main fontSize={14} textAlign="center">
                        Confirm this transaction in your wallet
                    </TYPE.main>
                </AutoColumn>
            </Section>
        </Wrapper>
    );
}

const ImageWrapper = styled.div`
    width: 100%;
    position: relative;
    height: 242px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: auto;
        height: 234px;
    }

    ${({ theme }) => theme.mediaWidth.upToSmall`
    height: 230px;
    `};
`;

const TextWrapper = styled(AutoColumn)`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 18px;
    flex-direction: column;
`;

function TransactionSubmittedContent({
    onDismiss,
    chainId,
    hash,
    addTokenToMetamask,
    summery,
}: {
    onDismiss: () => void;
    hash: string | undefined;
    chainId: ChainId;
    addTokenToMetamask?: Token;
    summery?: string;
}) {
    const [canAdd, addToMetaMask] = useAddToken(addTokenToMetamask);

    return (
        <Wrapper>
            <Section>
                <ImageWrapper>
                    <img src={require('assets/images/trans-success.png')} alt="" />
                </ImageWrapper>
                <TextWrapper>
                    <TYPE.main fontWeight={500} fontSize={20}>
                        Transaction Submitted
                    </TYPE.main>
                    {summery && (
                        <AutoColumn gap="12px" justify={'center'}>
                            <TYPE.main fontWeight={600} fontSize={14} textAlign="center" color="#fff">
                                {summery}
                            </TYPE.main>
                        </AutoColumn>
                    )}

                    {chainId && hash && (
                        <Link color="#fff" href={`${NETWORK_CONFIG[chainId].explore}tx/${hash}`}>
                            <TYPE.main fontWeight={500} fontSize={14} color="#fff">
                                View on {NETWORK_CONFIG[chainId].scanLable}
                            </TYPE.main>
                        </Link>
                    )}
                    {addTokenToMetamask && canAdd && (
                        <AddToken
                            onClick={() => {
                                addToMetaMask();
                            }}
                        >
                            <img className="metamaskLogo" src={metamaskSmallLogo} alt="netswap" /> Add{' '}
                            {addTokenToMetamask.symbol} to Metamask
                        </AddToken>
                    )}
                    <Button onClick={onDismiss} style={{ margin: '20px 0 0 0' }}>
                        Close
                    </Button>
                </TextWrapper>
            </Section>
        </Wrapper>
    );
}

export function TransactionErrorContent({ message, onDismiss }: { message: string; onDismiss: () => void }) {
    return (
        <Wrapper>
            <Section>
                <AutoColumn style={{ marginTop: 20, padding: '2rem 0' }} gap="24px" justify="center">
                    <AlertTriangle color="red" style={{ strokeWidth: 1.5 }} size={64} />
                    <TYPE.main
                        fontWeight={500}
                        fontSize={16}
                        color="red"
                        style={{
                            textAlign: 'center',
                            width: '85%',
                            wordBreak: 'break-word',
                        }}
                    >
                        {message}
                    </TYPE.main>
                </AutoColumn>
            </Section>
            <BottomSection gap="12px">
                <Button onClick={onDismiss}>Dismiss</Button>
            </BottomSection>
        </Wrapper>
    );
}

// interface ConfirmationModalProps {
//     isOpen: boolean;
//     onDismiss: () => void;
//     hash: string | undefined;
//     content: () => React.ReactNode;
//     attemptingTxn: boolean;
//     pendingText: string;
//     addTokenToMetamask?: Token;
// }

// function TransactionConfirmationModal({
//     isOpen,
//     onDismiss,
//     attemptingTxn,
//     hash,
//     pendingText,
//     content,
//     addTokenToMetamask,
// }: ConfirmationModalProps) {
//     const { chainId } = user;

//     if (!chainId) return null;

//     // confirmation screen
//     return (
//         <Modal isOpen={isOpen} onClose={onDismiss}>
//             {attemptingTxn ? (
//                 <ConfirmationPendingContent
//                     onDismiss={onDismiss}
//                     pendingText={pendingText}
//                 />
//             ) : hash ? (
//                 <TransactionSubmittedContent
//                     chainId={chainId}
//                     hash={hash}
//                     onDismiss={onDismiss}
//                     addTokenToMetamask={addTokenToMetamask}
//                 />
//             ) : (
//                 content()
//             )}
//         </Modal>
//     );
// }

function TransactionConfirmationModalWithErrorMessage() {
    const { chainId } = user;
    const {
        confirmModal: { isOpen, attemptingTxn, hash, pendingText, errorMessage, addTokenToMetamask, summery },
    } = application;

    function onDismiss() {
        application.setCloseConfirModalState();
    }

    if (!chainId) return null;

    // confirmation screen
    return (
        <Modal isOpen={isOpen} onClose={onDismiss}>
            {attemptingTxn ? (
                <ConfirmationPendingContent onDismiss={onDismiss} pendingText={pendingText} />
            ) : hash ? (
                <TransactionSubmittedContent
                    chainId={chainId}
                    hash={hash}
                    onDismiss={onDismiss}
                    addTokenToMetamask={addTokenToMetamask}
                    summery={summery}
                />
            ) : isOpen ? (
                <TransactionErrorContent
                    onDismiss={onDismiss}
                    message={errorMessage || 'Something wrong, please try again later'}
                />
            ) : null}
        </Modal>
    );
}

export default observer(TransactionConfirmationModalWithErrorMessage);
